import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    const testimonialSections = document.querySelectorAll('.js-section-testimonial-block');

    testimonialSections.forEach((section) => {
        new Swiper(section.querySelector('.js-section-testimonial-block-swiper'), {
            modules: [Autoplay, Pagination],
            loop: true,
            autoplay: {
                delay: 6000,
            },
            pagination: {
                el: section.querySelector('.js-section-testimonial-block-pagination'),
                clickable: true,
            },
        });
    });
});
